import React from "react";

import Header from './common/header';
import Footer from './common/footer';
export default class Color extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			colorR:192,
			colorG:192,
			colorB:192,
			colorH:0,
			colorS:0,
			colorV:75,
			rgbcolor:'#fff',
			highlight:'#fff'
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSubmitColor = this.handleSubmitColor.bind(this);
		this.highlightColor = this.highlightColor.bind(this);
	}

	handleInputChange(event) {
		const me = this;
		const target = event.target;
	    const name = target.name;
	    const value = target.value;
	    if(!/^\d+$/.test(value)) return;
	    me.setState({
	    	[name]: value
	    });
	}

	handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
		const me = this;
		const hsv = me.rgb2hsv(me.state.colorR,me.state.colorG,me.state.colorB);

		me.setState({
			colorH:hsv.h,
			colorS:hsv.s,
			colorV:hsv.v,
		});

		const rgb = {
			r:me.state.colorR,
			g:me.state.colorG,
			b:me.state.colorB
		};

		const hexcolor = me.RGB2hex(rgb);
		me.setState({
			rgbcolor:hexcolor
		});


	}

	handleSubmitColor(event) {
        event.preventDefault();
        event.stopPropagation();
		const me = this;
		const rgbColor = me.hsv2rgb(me.state.colorH,me.state.colorS,me.state.colorV);
		me.setState({
			colorR:rgbColor.r,
			colorG:rgbColor.g,
			colorB:rgbColor.b
		});
	}

	highlightColor(event){
        event.preventDefault();
        event.stopPropagation();
		const me = this;
		console.log(me.state.colorH);
		console.log(me.state.colorS);
		const rgbColor = me.hsv2rgb(me.state.colorH,me.state.colorS,100);
		const hexcolor = me.RGB2hex(rgbColor);
		me.setState({
			highlight:hexcolor
		});
	}

	hsv2rgb(h,s,v){
		var r,g,b;
		var var_r,var_g,var_b;
		h = h / 360; 
		s = s / 100; 
		v = v / 100;
		if (s === 0) {
			r = v * 255;
			g = v * 255;
			b = v * 255;
		} else {
			let var_h = h * 6;
			let var_i = Math.floor(var_h);
			let var_1 = v * (1 - s);
			let var_2 = v * (1 - s * (var_h - var_i));
			let var_3 = v * (1 - s * (1 - (var_h - var_i)));
			
			if (var_i === 0) {var_r = v; var_g = var_3; var_b = var_1}
			else if (var_i === 1) {var_r = var_2; var_g = v; var_b = var_1}
			else if (var_i === 2) {var_r = var_1; var_g = v; var_b = var_3}
			else if (var_i === 3) {var_r = var_1; var_g = var_2; var_b = v}
			else if (var_i === 4) {var_r = var_3; var_g = var_1; var_b = v}
			else {var_r = v; var_g = var_1; var_b = var_2};
			
			r = var_r * 255;
			g = var_g * 255;
			b = var_b * 255;
		}

		r = Math.ceil(r);
		g = Math.ceil(g);
		b = Math.ceil(b);

		return {
			r:r,g:g,b:b
		}

	}

	rgb2hsv (r,g,b) {

        r = r / 255;
        g = g / 255;
        b = b / 255;
		var rr, gg, bb,
	        h, s,
	        v = Math.max(r, g, b),
	        diff = v - Math.min(r, g, b),
	        diffc = function(c){
	            return (v - c) / 6 / diff + 1 / 2;
	        };

	    if (diff === 0) {
	        h = s = 0;
	    } else {
	        s = diff / v;
	        rr = diffc(r);
	        gg = diffc(g);
	        bb = diffc(b);

	        if (r === v) {
	            h = bb - gg;
	        }else if (g === v) {
	            h = (1 / 3) + rr - bb;
	        }else if (b === v) {
	            h = (2 / 3) + gg - rr;
	        }
	        if (h < 0) {
	            h += 1;
	        }else if (h > 1) {
	            h -= 1;
	        }
	    }
	    return {
	        h: Math.round(h * 360),
	        s: Math.round(s * 100),
	        v: Math.round(v * 100)
	    };
	}

	hexify(number) {
		var digits = '0123456789ABCDEF';
		var lsd = number % 16;
		var msd = (number - lsd) / 16;
		var hexified = digits.charAt(msd) + digits.charAt(lsd);
		return hexified;
	}


	RGB2hex (RGB) {
		const me = this;
		return "#" + me.hexify(RGB.r) + me.hexify(RGB.g) + me.hexify(RGB.b);
	}


	render() {
		let bgcolor = this.state.rgbcolor;
		let highlight = this.state.highlight;
		return (
			<div className="text-center">
			<Header />
			<div className="container py-3 my-3">
				<h1>Color</h1>
				<div style={{backgroundColor:bgcolor}} className="p-3 m-3 text-muted">
					RGB color : {this.state.rgbcolor}
				</div>
				<div style={{backgroundColor:highlight}} className="p-3 m-3 text-muted">
					HighLight color : {this.state.highlight}
				</div>
				<div className="row">
					<div className="col-5">
						<h2>RGB to HSV</h2>

						<form className="form-signin mt-5" onSubmit={this.handleSubmit}>

							<label className="sr-only">R</label>
							<input name="colorR" type="text"  className="form-control" placeholder="R"  required autoFocus onChange={this.handleInputChange} value={this.state.colorR} />

							<label className="sr-only">G</label>
							<input name="colorG" type="text"  className="form-control" placeholder="G"  required autoFocus onChange={this.handleInputChange} value={this.state.colorG} />


							<label className="sr-only">B</label>
							<input name="colorB" type="text"  className="form-control" placeholder="B"  required autoFocus onChange={this.handleInputChange} value={this.state.colorB} />


            				<button className="btn btn-lg btn-primary btn-block" type="submit">Change</button>
						</form>

						<h3>HSV</h3>
						<div>
							<p>{this.state.colorH} </p>
							<p>{this.state.colorS} </p>
							<p>{this.state.colorV} </p>
						</div>

					</div>


					<div className="col-5">
						<h2>HSV to RGB</h2>

						<form className="form-signin mt-5" onSubmit={this.handleSubmitColor}>

							<label className="sr-only">H</label>
							<input name="colorH" type="text"  className="form-control" placeholder="H"  required autoFocus onChange={this.handleInputChange} value={this.state.colorH} />

							<label className="sr-only">S</label>
							<input name="colorS" type="text"  className="form-control" placeholder="S"  required autoFocus onChange={this.handleInputChange} value={this.state.colorS} />


							<label className="sr-only">V</label>
							<input name="colorV" type="text"  className="form-control" placeholder="V"  required autoFocus onChange={this.handleInputChange} value={this.state.colorV} />


        					<button className="btn btn-lg btn-primary btn-block" type="submit">Change</button>

						</form>

						<h3>RGB</h3>
						<div>
							<p>{this.state.colorR} </p>
							<p>{this.state.colorG} </p>
							<p>{this.state.colorB} </p>
						</div>
					</div>


					<div className="col-2">
        					<button className="btn btn-lg btn-primary btn-block" type="button" onClick={this.highlightColor}>High Light</button>

					</div>
				</div>

			</div>

			<Footer />
			</div>
			)
	}
}



// WEBPACK FOOTER //
// ./src/apps/site/color.js